import { getAxios, postAxios } from "services/api/api.service";
import * as mocks from "./MyPoints.mock";
import { apiNames } from "services/api/endpoint.service";
import { getDateDifference } from "./MyPoints.util";


export function getTotalPoints(
	callback: Function,
	errorCallback: Function,
	mock?: any,
	t?:any
) {
	if (mock === "true") {
		const mockData = mocks.globalPoints;
		try {
			sessionStorage.setItem(
				"raas-trip-mock-data",
				JSON.stringify(mockData),
			);
		} catch (error) {
			sessionStorage.setItem("raas-trip-mock-data", "error saving mock");
		}
		const aux={
			...mockData.data,
			balance:new Intl.NumberFormat('es').format(Math.floor(mockData.data.pointsAmount)),
			diff:mockData.data.points[0]? getDateDifference(t,mockData.data.points[0]): null
			//diff:20+" "+t("getMyPointsLiterals.textPointsExpires")+"20"+"/"+"05"
		}
		callback(aux);
	} else {
		const apiWithParams = `/loyalty/v2/points`;
		getAxios(apiNames.PROFMANAG, true, apiWithParams)
			.then((data: any) => {
				const aux={
					...data.data,
					balance:new Intl.NumberFormat('es').format(Math.floor(data.data.pointsAmount)),
					diff:data.data.points[0] ? getDateDifference(t,data.data.points[0]):null
					//diff:t("getMyPointsLiterals.textPointsExpires")+"20"+"/"+"05"
				}
				callback(aux);
			})
			.catch((error: any) => {
				errorCallback(error);
			});
	}
}
export function getDiscountListCall(
	callback: Function,
	errorCallback: Function,
	mock?: any,
) {
	if (mock === "true") {
		const mockData = mocks.discountsAvailable;
		try {
			sessionStorage.setItem(
				"raas-trip-mock-data",
				JSON.stringify(mockData),
			);
		} catch (error) {
			sessionStorage.setItem("raas-trip-mock-data", "error saving mock");
		}
		let resultado=mockData.data.map((item: any) => {
			let day = item.Validity.substring(5, 7);
			let month = item.Validity.substring(8, 10);
			return {
			  ...item,
			  validityDate:day +" / "+month
			}
		  });
		callback(resultado);
	} else {
		const apiWithParams = `/loyalty/coupons/`;
		getAxios(apiNames.PROFMANAG, true, apiWithParams)
			.then((data: any) => {
				let resultado=data.data.map((item: any) => {
					let month = item.Validity.substring(5, 7);
					let day = item.Validity.substring(8, 10);
					return {
					  ...item,
					  validityDate:day +" / "+month
					}
				  });
				callback(resultado);
			})
			.catch((error: any) => {
				errorCallback(error);
			});
	}
}

/**
 * Canjear puntos listado
 * @param callback 
 * @param errorCallback 
 * @param mock 
 */
export function getPointsListCall(
	callback: Function,
	errorCallback: Function,
	mock?: any,

) {
	if (mock === "true") {
		const mockData = mocks.pointsAvailable;
		try {
			sessionStorage.setItem(
				"raas-trip-mock-data",
				JSON.stringify(mockData),
			);
		} catch (error) {
			sessionStorage.setItem("raas-trip-mock-data", "error saving mock");
		}
		let resultado=mockData.data.definitionDataList.map((item: any) => {
			let day = item.endConsumptionData.substring(5, 7);
			let month = item.endConsumptionData.substring(8, 10);
			return {
			  ...item,
			  validityDate:day +" / "+month
			}
		  });
		callback(resultado);
	} else {
		const apiWithParams = `/loyalty/campaigns`;
		getAxios(apiNames.PROFMANAG, true, apiWithParams)
			.then((data: any) => {
				let resultado=data?.data?.definitionDataList.map((item: any) => {
					let day = item.endConsumptionData.substring(5, 7);
					let month = item.endConsumptionData.substring(8, 10);
					return {
					  ...item,
					  validityDate:day +" / "+month
					}
				  });
				callback(resultado);
			})
			.catch((error: any) => {
				errorCallback(error);
			});
	}
}

export function wantDiscount(
    body: any,
    callback: Function,
    errorCallback: Function,
	mock: any,
	t:any
  ) {
	if (mock === "true") {
		const mockData = mocks.generatePoints;
		try {
			sessionStorage.setItem(
				"raas-trip-mock-data",
				JSON.stringify(mockData),
			);
		} catch (error) {
			sessionStorage.setItem("raas-trip-mock-data", "error saving mock");
		}
	
		let discountUpdate=mockData.data.discountUpdate.map((item: any) => {
			let day = item.Validity.substring(5, 7);
			let month = item.Validity.substring(8, 10);
			return {
			  ...item,
			  validityDate:day +" / "+month
			}
		  });
		const aux={
			balance:{
				//...mockData.data,
				balance:mockData.data.pointsAmount,
				diff:getDateDifference(t,mockData.data.points[0])
			},
			discountUpdate
		}
		callback(aux);
	}else{
		postAxios(apiNames.PROFMANAG, true, `/loyalty/v2/coupons/generate`, body)
		.then((data: any) => {
			let discountUpdate=data.data.discountUpdate.map((item: any) => {
				let day = item.Validity.substring(5, 7);
				let month = item.Validity.substring(8, 10);
				return {
				  ...item,
				  validityDate:day +" / "+month
				}
			  });
			const aux={
				balance:{
					...data.data,
					balance:new Intl.NumberFormat('es').format(Math.floor(data.data.pointsAmount)),
					diff:getDateDifference(t,data.data.points[0])
				},
				discountUpdate
			}
			callback(aux)
		  }).catch((error) => {
			errorCallback(error);
		  })



	
	}
  }
